// LogoSlider.js
import React from "react";
import "./LogoSlider.css"; // Add your CSS file

const LogoSlider = () => {
  return (
    <div className="logo-slider">
      <div className="logos-slide">
        <img src="/react.png" alt="Verzon" />
        <img src="/html.png" alt="Netflix" />
        <img src="/css.png" alt="Yelp" />
        <img src="/bootstrap.webp" alt="Adobe" />
        <img src="/flask.png" alt="Ring" />
        <img src="/mssql.png" alt="Nespresso" />
        <img src="/suricata.jpg" alt="Nespresso" />
        <img src="/kali.png" alt="Nespresso" />
        <img src="/npm.webp" alt="Nespresso" />
      </div>
      <div className="logos-slide">
      <img src="/react.png" alt="Verzon" />
        <img src="/html.png" alt="Netflix" />
        <img src="/css.png" alt="Yelp" />
        <img src="/bootstrap.webp" alt="Adobe" />
        <img src="/flask.png" alt="Ring" />
        <img src="/mssql.png" alt="Nespresso" />
        <img src="/suricata.jpg" alt="Nespresso" />
        <img src="/kali.png" alt="Nespresso" />
        <img src="/npm.webp" alt="Nespresso" />
      </div>
    </div>
  );
};

export default LogoSlider;
